import React from 'react';

const SectionImage = () => {
  return (
    <div className="section-divider" data-aos="fade-in">
      <img src="/image2.png" alt="C.H.I. Logistics on the road" />
      <div className="section-divider__overlay">
        <p className="section-divider__text">Delivering Excellence Across America</p>
        <p className="section-divider__sub">
          From coast to coast — safe, reliable, and on schedule.
        </p>
      </div>
    </div>
  );
};

export default SectionImage;
